import * as React from 'react';
import { ILinks5Data } from '../absolute-ff.props.autogenerated';

export interface IContentCardLinks5 {
    links5: ILinks5Data[];
}

const ContentCardLinks5: React.FC<IContentCardLinks5> = ({ links5 }) => (
    <div className='ms-content-block__cta'>
        {links5.map((cta: ILinks5Data, index: number) => {
            const btnClass = index === 0 ? 'msc-cta__primary' : 'msc-cta__secondary';
            return <a
                key={`link-${index}`}
                className={btnClass}
                role='button'
                title={cta.linkText}
                href={cta.linkUrl && cta.linkUrl.destinationUrl}
                aria-label={cta.ariaLabel}
                target={cta.openInNewTab ? '_blank' : undefined}
            >
                {cta.linkText}
            </a>;
        })}
    </div>
);

export default ContentCardLinks5;